'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = loadExtScript;
function loadExtScript(src, test, callback) {
  var tryCallingTest = function tryCallingTest() {
    var call = false;
    try {
      call = test.call();
    } catch (exception) {
      console.log('exception: ' + exception);
    }

    if (call && callback) {
      callback.call();
    }

    return call;
  };

  if (tryCallingTest()) {
    return;
  }

  var script = document.createElement('script');
  script.src = src;
  document.body.appendChild(script);

  var callbackTimer = setInterval(function () {
    if (tryCallingTest()) {
      clearInterval(callbackTimer);
    }
  }, 100);
}
module.exports = exports['default'];


/*****************
 ** WEBPACK FOOTER
 ** ./src/utils/scriptLoader.js
 ** module id = 1408
 ** module chunks = 0
 **/